import callApi from "./callApi";

export const getUserNotifications = async (page, pageSize, filterUnread=false) => {
  const url = `notifications?page=${page}&pageSize=${pageSize}&filterUnread=${filterUnread}`;
  const headers = {};
  return callApi(url, headers, "GET");
};

export const markAllRead = async () => {
  const url = `notifications/mark_all_read`;
  const headers = {};
  return callApi(url, headers, "PUT");
};

export const markNotificationRead = async (id) => {
  const url = `notifications/mark_read/${id}`;
  const headers = {};
  return callApi(url, headers, "PUT");
};

export const clearAllNotifications = async () => {
  const url = `notifications/clear_all`;
  const headers = {};
  return callApi(url, headers, "PUT");
};
